import { type DefaultTheme, css } from 'styled-components';

/**
 * Extract checkbox styles for reuse in global styles
 */

export const agGridCheckboxStyles = (theme: DefaultTheme) => css`
  .ag-checkbox-input-wrapper.ag-checked::after {
    // Needed some additional specificness for this specific var
    --ag-checkbox-checked-color: ${theme.colors.white.default};
  }
  --ag-checkbox-indeterminate-color: ${theme.colors.white.default};
  --ag-checkbox-unchecked-color: ${theme.colorTextDefault};
  .ag-checkbox-input-wrapper {
    box-shadow: none;
    border: 1px solid ${theme.borderColorCheckbox};
    background: ${theme.backgroundCheckbox};
    &:focus-within {
      border: 1px solid ${theme.borderColorCheckboxFocus};
    }
    &:hover {
      background: ${theme.backgroundCheckboxHover};
    }
    &.ag-checked {
      background: ${({ theme }) => theme.backgroundCheckboxChecked};
      border: 1px solid ${({ theme }) => theme.borderColorCheckboxChecked};
      &:after {
        opacity: 1;
      }
    }
    &.ag-indeterminate {
      background: ${({ theme }) => theme.backgroundCheckboxChecked};
      border: 1px solid ${({ theme }) => theme.borderColorCheckboxChecked};
      &:after {
        content: '\\e996';
        opacity: 1;
      }
    }
    &:after {
      font-family: helixicons;
      content: '\\e92b';
      font-size: ${({ theme }) => theme.fontSizeDefault}rem;
      opacity: 0;
      transition: opacity 200ms ease;
    }
  }
`;
